/**
 * Resolves userId for copy-google-doc invoke body.
 * Optional system_settings.google_user_id override, otherwise the default Google doc-gen org account id.
 * Uses maybeSingle() so missing rows do not produce PostgREST 406 responses.
 */
export async function resolveGoogleDocGenUserId(supabase) {
  const { data: systemSettings } = await supabase
    .from("system_settings")
    .select("setting_value")
    .eq("setting_key", "google_user_id")
    .maybeSingle();

  if (systemSettings?.setting_value) {
    return systemSettings.setting_value;
  }

  const { data: orgAccount } = await supabase
    .from("organization_email_accounts")
    .select("id")
    .eq("provider", "google")
    .eq("is_default_for_doc_gen", true)
    .eq("is_active", true)
    .maybeSingle();

  return orgAccount?.id ?? null;
}
